module.exports = __webpack_public_path__ + "static/explainer2-alt-2f7b327017c6bce4bbb7915c8164999f.png";